<template>
  <el-tabs v-model="activeName" @tab-click="handleClick">

    <el-tab-pane label="电流不平衡度" lazy name="second">
      <dianliu :date="date" :dateType="dateType"></dianliu>
    </el-tab-pane>
    <el-tab-pane label="环境温度统计" lazy name="third">
      <huanjing :date="date" :dateType="dateType"></huanjing>
    </el-tab-pane>
    <el-tab-pane label="电能质量" lazy name="fourth">
      <dianneng :date="date" :dateType="dateType"></dianneng>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
  import dianliu from "./ydfx/dianliu";
  import huanjing from "./ydfx/huanjing";
  import dianneng from "./ydfx/dianneng";
  export default {
    name: "ztgy",
    data () {
      return {
        activeName: 'second'
      };
    },
    props: {
      date: {
        type: String
      },
      dateType: {
        type: String
      },
    },
    components: { dianliu, huanjing, dianneng },
    mounted () {

    },
    computed: {

    },
    watch: {

    },
    methods: {
      handleClick (tab, event) {
        console.log(tab, event);
      },
    },
  };
</script>

<style lang="less">
  .el-tabs {
    .el-tabs__header {
      margin: 0 0 1px;

      .el-tabs__nav-wrap {
        padding-left: 20px;
        background: #f8f8f9;
      }
    }
  }
</style>